let audioCtx = null

export function getAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)()
  }
  return audioCtx
}

export function playWarningBeep({
  times = 3,
  frequency = 1000,
  duration = 180, // ms per beep
  gap = 120, // jeda antar beep
  volume = 0.18, // 🔊 lebih kenceng (sebelumnya 0.04)
} = {}) {
  const ctx = getAudioContext()
  if (ctx.state !== 'running') return

  let startTime = ctx.currentTime

  for (let i = 0; i < times; i++) {
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()

    osc.type = 'sine'
    osc.frequency.value = frequency

    // smooth attack & release (biar gak nyetrum telinga)
    gain.gain.setValueAtTime(0, startTime)
    gain.gain.linearRampToValueAtTime(volume, startTime + 0.02)
    gain.gain.linearRampToValueAtTime(0, startTime + duration / 1000)

    osc.connect(gain)
    gain.connect(ctx.destination)

    osc.start(startTime)
    osc.stop(startTime + duration / 1000)

    startTime += (duration + gap) / 1000
  }
}
